import './App.scss'

import { Auth0Provider } from '@auth0/auth0-react'
// import { getToken, onMessage } from 'firebase/messaging'
import React, { Suspense } from 'react'
import { BrowserRouter } from 'react-router-dom'

import useNotify from './hooks/useNotify'
import useRedux from './hooks/useRedux'
import useTranslations from './hooks/useTranslations'
import { setPopupMessageModel } from './redux/app/action'
import Routing from './routing'
// import { messaging } from './services/firebase'
import PopUpConfirm from './shared/PopUpConfirm'

let notifyMethod

function App() {
  const { t } = useTranslations()
  const { notify, contextHolder } = useNotify()
  const { selector, dispatch } = useRedux()
  const popup = selector(state => state?.app?.popUpMsgModel)
  const { open, message, success } = { ...popup }

  // useEffect(() => {
  //
  //   Notification.requestPermission()
  //     .then(() =>
  //       getToken(messaging, {
  //         vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
  //       }),
  //     )
  //     .then(currentToken => {
  //       if (currentToken) {
  //         setItem('FCMToken', currentToken)
  //       } else {
  //         // Show permission request UI
  //       }
  //     })
  //     .catch(err => {})

  //   onMessage(messaging, payload => {
  //     // ...
  //   })
  // }, [])
  notifyMethod = notify
  return (
    <BrowserRouter>
      <Suspense
        fallback={
          <div className="main-loader">
            <span>{t('txt_Loading')}</span>
          </div>
        }
      >
        {contextHolder}
        <Auth0Provider
          domain={process.env.REACT_APP_AUTH0_DOMAIN}
          clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
          authorizationParams={{
            redirect_uri: process.env.REACT_APP_REDIRECT_URL,
          }}
        >
          <Routing />
        </Auth0Provider>
        {open && (
          <PopUpConfirm
            isOpen={open}
            success={success}
            description={t(message)}
            onCancelModel={() =>
              dispatch(setPopupMessageModel({ open: false, message: '' }))
            }
          />
        )}
      </Suspense>
    </BrowserRouter>
  )
}

export { notifyMethod }
export default App
